<!-- Left pane — kørsler -->
<div class="d-flex flex-column h-100 pane-left">
    <div class="card h-100 d-flex flex-column">

        <div class="card-header flex-shrink-0">
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    Kørsler
                </h5>
                <div class="d-flex align-items-center gap-2">
                    <select class="form-select form-select-sm template-select"
                        aria-label="Filtrér på skabelon"
                        [value]="queryFilters().templateId ?? ''"
                        (change)="onTemplateChange($any($event.target).value)">
                        <option value="">Vis alle skabeloner</option>
                        @for (template of templatesResource.value() ?? []; track template.id) {
                            <option [value]="template.id">{{ template.name }}</option>
                        }
                    </select>
                    <button class="btn btn-sm btn-primary" (click)="reload()" title="Genindlæs">
                        <i class="fa-solid fa-arrow-rotate-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="card-header flex-shrink-0 d-flex flex-column">
            <app-queue-request-filters [(query)]="queryFilters" [counts]="counts()" />
        </div>

        @if (pollingStopped()) {
            <!-- Say the live view stopped rather than letting it look merely quiet. -->
            <div class="poll-stopped flex-shrink-0">
                <i class="fa-solid fa-triangle-exclamation me-2" aria-hidden="true"></i>
                Overvågningen er sat på pause efter gentagne fejl.
                <button type="button" class="btn btn-link btn-sm p-0 align-baseline"
                    (click)="resumePolling()">Genoptag</button>
            </div>
        }

        <div class="card-body p-0 flex-grow-1 overflow-hidden">
            <app-queue-request-list
                [rows]="rows()"
                [selectedId]="selectedId()"
                [focusId]="focusId()"
                [loading]="loading()"
                [loadingMore]="loadingMore()"
                [hasMore]="hasMore()"
                [error]="listError()"
                [searchActive]="searchActive()"
                (select)="onSelect($event)"
                (loadMore)="onLoadMore()"
                (retry)="reload()" />
        </div>
    </div>
</div>

<!-- Right pane — the accordion. Never inside an @if, so its folded/unfolded header survives a
     selection change. -->
<div class="d-flex flex-column h-100 flex-grow-1 pane-right">
    <app-queue-request-detail
        [request]="selectedDetail()"
        [customerName]="selectedNames().customerName"
        [companyName]="selectedNames().companyName"
        [synchronizationName]="selectedNames().synchronizationName"
        [loading]="detailResource.isLoading()"
        [error]="detailError()"
        (downloadPayload)="onDownloadPayload($event)"
        (copyLink)="copyLink()" />
</div>
